exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".uxfeIHbXDzj4455M0anZR ._331Z8rHouvUFLl17KoWq1u {\n  padding: 10px;\n}\n\n.uxfeIHbXDzj4455M0anZR ._331Z8rHouvUFLl17KoWq1u ._2EWQE9x226VrhlS1ZkFh_- {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"custom-ranges": "uxfeIHbXDzj4455M0anZR",
	"ant-picker-footer": "_331Z8rHouvUFLl17KoWq1u",
	"flex-wrap": "_2EWQE9x226VrhlS1ZkFh_-"
};